// モーダル機能を提供する関数。onOpenCallbackはモーダル表示時に実行されるコールバック関数
export const originalModal = (onOpenCallback) => {
  let currentModal = null; // 現在表示中のモーダル
  const modalBackdrop = document.getElementById('modalBackdrop'); // 背景のオーバーレイ

  if (!modalBackdrop) return; // オーバーレイが存在しない場合は処理終了

  // モーダルを開く関数
  function openModal(modal, animationClass = 'fade-in') {
    if (!modal || modal === currentModal) return; // 無効または既に表示中なら無視

    // 表示中のモーダルと異なる場合は、先に閉じてから新しいモーダルを開く
    if (currentModal && currentModal !== modal) {
      const outClass =
        currentModal.dataset.out || // data-out属性でカスタムアニメーションが指定されていればそれを使用
        (currentModal.classList.contains('modal-bottom') ? 'slide-down' : 'fade-out');

      // 現在のモーダルのアニメーション終了後に新しいモーダルを開く
      currentModal.addEventListener(
        'animationend',
        () => {
          currentModal.style.display = 'none';
          doOpen(modal, animationClass);
        },
        { once: true },
      );

      // 現在のモーダルを閉じる
      closeModal(currentModal, outClass, false);
    } else {
      // すぐにモーダルを開く
      doOpen(modal, animationClass);
    }
  }

  // 実際にモーダルを表示する処理
  function doOpen(modal, animationClass) {
    modal.style.display = 'block';
    modal.classList.remove('fade-out', 'slide-down');
    modal.classList.add(animationClass);

    const scrollable = modal.querySelector('.option-block');
    if (scrollable) scrollable.scrollTop = 0;

    modalBackdrop.style.display = 'block';
    modalBackdrop.classList.remove('fade-out');
    modalBackdrop.classList.add('fade-in');

    // 背景のスクロールを停止
    document.body.classList.add('no-scroll');

    currentModal = modal;

    if (typeof onOpenCallback === 'function') {
      onOpenCallback(modal);
    }
  }

  // モーダルを閉じる関数
  function closeModal(modal, animationClass = 'fade-out', clearCurrent = true, onCloseCallback) {
    if (!modal) return;

    modal.classList.remove('fade-in', 'slide-up');
    modal.classList.add(animationClass);

    modal.addEventListener(
      'animationend',
      () => {
        modal.style.display = 'none';
        modal.classList.remove(animationClass);

        if (typeof onCloseCallback === 'function') {
          onCloseCallback(modal);
        }
      },
      { once: true },
    );

    modalBackdrop.classList.remove('fade-in');
    modalBackdrop.classList.add('fade-out');

    const onBackdropAnimationEnd = () => {
      if (!currentModal) {
        modalBackdrop.style.display = 'none';
        // モーダルが完全に閉じた時にスクロールを復元
        document.body.classList.remove('no-scroll');
      }
      modalBackdrop.classList.remove('fade-out');
      modalBackdrop.removeEventListener('animationend', onBackdropAnimationEnd);
    };

    modalBackdrop.addEventListener('animationend', onBackdropAnimationEnd);

    if (clearCurrent) {
      currentModal = null;
    }
  }

  // 背景クリックでモーダルを閉じる機能（コメントアウト中）
  /*
  modalBackdrop.addEventListener('click', () => {
    if (currentModal) {
      const outClass = currentModal.dataset.out || 'fade-out';
      closeModal(currentModal, outClass, true);
    }
  });
  */

  // data-modal-target 属性を持つボタンからモーダルを開く処理
  const modalButtons = document.querySelectorAll('[data-modal-target]');
  modalButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const targetId = button.dataset.modalTarget;
      const targetModal = document.getElementById(targetId);
      if (!targetModal) return;

      // モーダルの位置に応じてアニメーションを決定
      const animationClass = targetModal.classList.contains('modal-bottom')
        ? 'slide-up'
        : 'fade-in';

      openModal(targetModal, animationClass);
    });
  });

  // data-close 属性を持つ要素がクリックされたらモーダルを閉じる
  const closeButtons = document.querySelectorAll('[data-close]');
  closeButtons.forEach((button) => {
    button.addEventListener('click', () => {
      const modal = button.closest('.modal'); // 親モーダルを取得
      if (!modal) return;
      const outClass = modal.dataset.out || 'fade-out';
      closeModal(modal, outClass);
    });
  });

  // 外部からモーダルの開閉ができるように関数を返す
  return {
    openModal,
    closeModal,
  };
};
